import "./sidebar.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import newWindow from "../../assets/svgs/newWindow.svg";
import home from "../../assets/svgs/homeSideBar.svg";
import hamb from "../../assets/svgs/hamb.svg";
import closeSideBar from "../../assets/svgs/closeSideBar.svg";
import logoutSideBar from "../../assets/svgs/logoutSideBar.svg";
import dashboard from "../../assets/svgs/dashboard.svg";
import aprovador from "../../assets/img/aprovador.png";
import userService from "../../assets/svgs/userService.svg";
import referenceRule from "../../assets/svgs/referenceRule.svg";
import { AppDispatch, RootState } from "../../redux/store";
import { useState } from "react";
import { clearSession } from "../../redux/slices/sessionSlice";
import { gotoLogout } from "../../utils/authUtils";
import Modal from "../../componentes/modal/modal";
import { useRoles } from "../../hooks/roles";
import { useAdminGroups } from "../../hooks/useAdminGroups";
import { Tooltip } from "@mui/material";

interface OverlayProps {
  isVisible: boolean;
  onClose: () => void;
}

// Fora do Sidebar
const Overlay = ({ isVisible, onClose }: OverlayProps) => {
  if (!isVisible) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: "0.5s ease-in-out",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9997,
      }}
    />
  );
};

const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [, setActiveSubMenu] = useState<string | null>(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [modalLogout, setModalLogout] = useState<boolean>(false);
  const [isZoom] = useState<number>(100);
  const { isTax, isEngineer } = useRoles();
  const { isGroupAdmin } = useAdminGroups();

  const { basicUserInfo } = useSelector((state: RootState) => state.user);

  const handleHomeClick = () => {
    localStorage.removeItem("endDate");
    localStorage.removeItem("startDate");
    localStorage.removeItem("classificationQuizStartDate");
    localStorage.removeItem("classificationQuizFinishDate");
    localStorage.removeItem("classificationApprovalStartDate");
    localStorage.removeItem("classificationApprovalEndDate");
    localStorage.removeItem("emitentePartNumber");
    localStorage.removeItem("selectedCenter");

    navigate("/");
    dispatch(clearSession());
  };

  const closeSidebar = () => {
    setActiveSubMenu(null);
    setIsSidebarOpen(false);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const goTo = (path: string) => {
    navigate(path);
    localStorage.removeItem("endDate");
    localStorage.removeItem("startDate");
    localStorage.removeItem("classificationQuizStartDate");
    localStorage.removeItem("classificationQuizFinishDate");
    localStorage.removeItem("classificationApprovalStartDate");
    localStorage.removeItem("classificationApprovalEndDate");
    localStorage.removeItem("emitentePartNumber");
  };

  const renderMenuContent = () => {
    if (isTax) {
      return (
        <div style={{ width: "100%", marginLeft: -30, marginTop: 11 }}>
          <div
            id="btn-dashboard"
            className="menuItem"
            onClick={() => goTo("/dashboard")}
          >
            <img src={dashboard} alt="Dashboard" className="menuIcon" />
            <span className="menuTitle">Dashboard</span>
          </div>

          <div
            id="btn-aprovador"
            className="menuItem"
            onClick={() => goTo("/aprovador-engenheiro")}
          >
            <img
              src={aprovador}
              alt="Aprovador"
              className="menuIcon aprovador"
            />
            <span className="menuTitle">Aprovador Engenheiro</span>
          </div>

          <div style={{ width: "100%"}} className="menuItem">
            <button
              id="btn-gruposResponsabilidade"
              className="menuItemButtonGrupoResponsabilidade"
              onClick={() => goTo("/grupos-responsabilidade")}
              type="button"
              style={{ padding: 0}}
              onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                goTo("/grupos-responsabilidade");
              }
            }}
            tabIndex={0}
            >
              <img
                src={userService}
                alt="Grupos de Responsabilidade"
                className="menuIcon grupoResponsabilidade"
              />
              <span className="menuTitle grupoResponsabilidade">Grupos de Responsabilidade</span>
            </button>
          </div>
        </div>
      );
    }

    if (isEngineer) {
      return (
        <>
          <div style={{ width: "100%", marginLeft: -30, marginTop: 11 }}>
            <div id="btn-newWindow" className="menuItem">
              <Tooltip title="Essa opção não está disponivel!" placement="right">
                <img src={newWindow} alt="" style={{ width: 24, height: 24 }} />
              </Tooltip>
              <span className="menuTitle" style={{ marginLeft: 15 }}>
                Emissão de Laudo
              </span>
            </div>
          </div>

          <div style={{ width: "100%", marginTop: 11 }}>
            {basicUserInfo.has_crea && basicUserInfo.is_eng_approver && (
              <button
                id="btn-associadosEng"
                className="menuItem menuItemButton"
                onClick={() => goTo("/usuarios-associados")}
                type="button"
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    goTo("/usuarios-associados");
                  }
                }}
              >
                <img
                  src={aprovador}
                  alt="Associar Usuários"
                  className="menuIcon aprovador"
                />
                <span className="menuTitle">Associar Usuários</span>
              </button>
            )}
          </div>
        </>
      );
    }
  };

  return (
    <>
      <Overlay isVisible={isSidebarOpen} onClose={closeSidebar} />
      <div
        className={`perfilContent ${isSidebarOpen ? "expanded" : ""}`}
        data-testid="sidebar"
        style={{
          zIndex: 9997,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          position: "fixed",
        }}
        id="sidebarId"
      >
          {isSidebarOpen || isZoom < 90 ? (
          <div className="headerSideBar">
              <h2 className="h2Title">Menu</h2>
              <button
                onClick={toggleSidebar}
                aria-label="Close sidebar"
                >
                <img
                  src={closeSideBar}
                  alt="Close sideBar"
                  style={{ marginRight: 40, marginTop: 34 }}
                />
              </button>
          </div>
          ) : (
            <div className="headerSideBar">
              <button
                onClick={toggleSidebar}
                aria-label="menu"
                className="iconButton"
              >
                <img
                  src={hamb}
                  alt="menu"
                  className="menuIconH"
                />
              </button>
            </div>
          )}

        <button id="btn-home" className="menuItem" onClick={handleHomeClick} style={{paddingLeft: 15}}>
          <img src={home} alt="home" className="menuIcon" />
          <span className="menuTitle">Home</span>
        </button>

        {renderMenuContent()}

        {isGroupAdmin && (
          <div style={{ width: "100%", marginLeft: -30 }}>
            <div style={{ width: "100%"}} className="menuItem">
              <button
                id="btn-regrasGrupo"
                className="menuItemButtonGrupoResponsabilidade"
                onClick={() => goTo("/config-grupos")}
                type="button"
                style={{ padding: 0}}
                onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  goTo("/config-grupos");
                }
              }}
              tabIndex={0}
              >
                <img
                  src={referenceRule}
                  alt="Regras do Grupo"
                  className="menuIcon grupoResponsabilidade"
                />
                <span className="menuTitle grupoResponsabilidade">Regras do Grupo</span>
              </button>
            </div>
          </div>
        )}

        <div style={{ width: "100%", marginLeft: -30 }}>
          <button
            id="btn-logoutCount"
            className="menuItem logoutItem"
            onClick={() => setModalLogout(true)}
            style={{paddingLeft: 15}}
          >
            <img
              src={logoutSideBar}
              alt="Deslogar da sessão"
              className="menuIcon"
            />
            <span className="menuTitle">Logout</span>
          </button>
        </div>
      </div>

      {modalLogout && (
        <Modal
          titleDescriptions="Você tem certeza de que deseja sair?"
          titleModal="Aviso"
          bodyModal={
            <span style={{ marginTop: "-10px" }}>
              Você será direcionado à página de logout e poderá sair com
              segurança do sistema.
            </span>
          }
          onClose={() => setModalLogout(false)}
          onConfirm={() => gotoLogout()}
          buttonOne="Sim"
          buttonTwo="Não"
          className="modalLogout"
        />
      )}
    </>
  );
};

export default Sidebar;
